import type { Client } from 'api/client/models';
import { getClients } from 'api/client';

export const fetchAllClientsByBlocks = async (): Promise<Client[]> => {
  const limit = 500;
  let page = 1;
  let allClients: Client[] = [];
  let total = 0;
  let loadMore = true;

  while (loadMore) {
    const {
      data: dataResponse,
      success,
      errorMessage,
    } = await getClients({
      page,
      pageSize: limit,
      order: 'name',
      filterBy: 'NEW_WAY',
    });

    if (!success || !dataResponse?.data) {
      throw new Error(errorMessage || 'CLIENT_FETCH_ERROR');
    }

    const { data, pagination } = dataResponse;

    allClients = [...allClients, ...data];
    total = pagination?.total || allClients.length;

    if (allClients.length >= total) {
      loadMore = false;
    }

    page += 1;
  }

  return allClients;
};

export const upsertClientInArray = (
  clients: Client[],
  updatedClient: Client,
) => {
  const idx = clients.findIndex((c) => c.clientId === updatedClient.clientId);
  if (idx === -1) return [updatedClient, ...clients];
  const next = [...clients];
  next[idx] = { ...next[idx], ...updatedClient };
  return next;
};

export const updateExistingClientInArray = (
  clients: Client[],
  updatedClient: Client,
) => {
  const idx = clients.findIndex((c) => c.clientId === updatedClient.clientId);
  if (idx === -1) return clients; // No agregar
  const next = [...clients];
  next[idx] = { ...next[idx], ...updatedClient };
  return next;
};
